import { ButtonLink } from '@change-corgi/design-system-legacy/components/actions';
import { Card } from '@change-corgi/design-system-legacy/components/content';
import { Box } from '@change-corgi/design-system-legacy/layout';

import { useCTAButtonVariant } from 'src/app/pages/starterDashboardV2/shared/contexts';
import { Waypoint } from 'src/app/shared/components/scroll';

import { useDashboardReskinExperiment } from '../../../../hooks/useDashboardReskinExperiment';

import { DmCards } from './components/DmCards';
import { DmOverview } from './components/DmOverview';
import { useDecisionMakersList } from './hooks/useDecisionMakersList';
import { DecisionMakersListReskin } from './index_new';

export function DecisionMakersList(): React.JSX.Element | null {
	const {
		data: { petitionEditPage, dmSources, decisionMakers },
		actions: { trackAddOrEditDmsClick, trackView },
	} = useDecisionMakersList();
	const {
		data: { isEnabled },
	} = useDashboardReskinExperiment();

	const { getCTAVariant } = useCTAButtonVariant();

	if (isEnabled) return <DecisionMakersListReskin />;

	return (
		<Box as="section">
			<Card
				backgroundColor="white"
				data-testid="mock-decision-makers-list"
				sx={{
					border: 'unset',
					width: '100%',
					borderRadius: 'big',
				}}
			>
				<Box>
					<Waypoint onEnter={() => trackView()} />

					<Box
						sx={{
							width: '100%',
						}}
					>
						<DmOverview dmSources={dmSources} />

						<Box sx={{ flex: 1 }}>
							<Box
								sx={{
									overflowY: 'auto',
									maxHeight: '320px',
									background:
										decisionMakers.length > 2 ? 'linear-gradient(to top, lightGrey, transparent 10%)' : 'none',
								}}
							>
								<DmCards />
							</Box>

							<Box p={24}>
								<ButtonLink
									data-qa="edit-decision-makers-button"
									variant={getCTAVariant('secondaryEmphasis')}
									my={8}
									sx={{ width: '100%' }}
									to={petitionEditPage}
									onClick={trackAddOrEditDmsClick}
								>
									{decisionMakers.length > 0 ? 'Edit Decision Makers' : 'Add Decision Makers'}
								</ButtonLink>
							</Box>
						</Box>
					</Box>
				</Box>
			</Card>
		</Box>
	);
}
